import { useEffect, useMemo } from "react";
import { AdditiveBlending, Color, EdgesGeometry, LineBasicMaterial, LineSegments, MeshStandardMaterial, Object3D } from "three";
import { findObjectStartsWithKey } from "../../../../../utils/FindObjects";

const MachineSize = ({ object3d, ...props }) => {
  const object = useMemo(() => {
    return findObjectStartsWithKey("EFD_HL_Maschine_size", object3d);
  }, []);

  const baseMat = useMemo(() => {
    return new MeshStandardMaterial({
      color: new Color("#3eba7c"),
      // color: new Color("#1ea5e3"),
      transparent: true,
      opacity: 0.1,
      depthWrite: false,
      depthTest: false,
      metalness: 0.1,
      roughness: 0.8,
      blending: AdditiveBlending,
      // emissive: 0xff0000,
    });
  }, []);

  const wireframeGeometry = useMemo(() => {
    var wireFrameGroup = new Object3D();

    object.traverse((c) => {
      if (c.isMesh) {
        var edges = new EdgesGeometry(c.geometry, 15);

        const mat = new LineBasicMaterial({
          color: new Color("#ffffff"),
          opacity: 0.05,
          depthTest: false,
          depthWrite: false,
          transparent: true,
          blending: AdditiveBlending,
        });

        const mat2 = new LineBasicMaterial({
          color: new Color("#3eba7c"),
          opacity: 1.0,
          depthTest: false,
          depthWrite: false,
          transparent: true,
          blending: AdditiveBlending,
        });

        let line = new LineSegments(edges, mat);
        line.computeLineDistances();
        line.renderOrder = 3;
        line.visible = true;

        line.position.copy(c.parent.position);

        // wireFrameGroup.add(line);

        var clone = line.clone();
        clone.material = mat2;
        wireFrameGroup.add(clone);
      }
    });

    return wireFrameGroup;
  }, [object]);

  useEffect(() => {
    if (object) {
      object.traverse((c) => {
        if (c.isMesh) {
          c.material = baseMat;
        }
      });
    }
  }, [object]);

  useEffect(() => {
    object.visible = true;
    return () => {
      object.visible = false;
    };
  }, []);

  return (
    <group>
      {/* <Clone object={object} /> */}
      <primitive object={wireframeGeometry} />
    </group>
  );
};

export default MachineSize;
